<top-bar-filters
  [valuesMap]="valuesMap"
  (updateValuesMap)="updateValuesMap($event)"
  [reactiveForm]="filtersForm"
  [formLayoutConfig]="filtersLayoutConfig"
  [formControlsConfigMap]="filtersConfigMap"
  (onApply)="applyFilters()"
  (onClear)="clearFilters()"
>
</top-bar-filters>
@if (isFetchingTickets) {
  <div class="loading__container d-flex justify-content-center align-items-center">
    <mat-spinner [diameter]="36"></mat-spinner>
    <span class="loading__container-text ml-3">Loading tickets data</span>
  </div>
}
@if (!isFetchingTickets && (dataSource?.length ?? 0) === 0) {
  <div class="loading__container d-flex flex-column justify-content-center align-items-center">
    <img class="mb-2" src="../../../../../assets/svg/empty-state_no-ticket-data.svg" alt="" />
    <span style="font-weight: bold; margin-bottom: 0.5rem; color: #979797">No Tickets Data</span>
  </div>
}
<div [hidden]="isFetchingTickets || (dataSource?.length ?? 0) === 0">
  <div class="udt-table-container">
    <table matSort mat-table [dataSource]="dataSource" (matSortChange)="onSortEvent($event)" class="udt-table w-100">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Ticket ID</th>
        <td mat-cell *matCellDef="let element" style="width: 130px; padding-right: 15px">
          <a [routerLink]="['/secured/managed-services/tickets', element.id]">
            {{ element.id }}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="statusName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let element">
          <div class="d-flex justify-content-start align-items-baseline">
            <div>
              <div class="status__dot mr-2" [ngStyle]="{ background: element.statusColor }"></div>
            </div>
            <span>{{ element.statusName }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="summary">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Summary</th>
        <td mat-cell *matCellDef="let element" style="width: 20%; padding-right: 20px">
          <div
            #summaryCell
            class="two-line-text"
            matTooltipClass="bigger-tooltip"
            [matTooltip]="summaryCell.scrollHeight > summaryCell.clientHeight ? element.summary : ''"
          >
            {{ element.summary }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="priorityName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Priority</th>
        <td mat-cell *matCellDef="let element">{{ element.priorityName }}</td>
      </ng-container>

      <ng-container matColumnDef="relationship">
        <th mat-header-cell *matHeaderCellDef>Parent</th>
        <td mat-cell *matCellDef="let item" style="width: 130px; padding-right: 10px">{{ item.isParent }}</td>
      </ng-container>

      <ng-container matColumnDef="dateEntered">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Creation</th>
        <td mat-cell *matCellDef="let element">
          {{ element.dateEntered ? (element.dateEntered | hubDate: 'isoDate') : '' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="lastUpdated">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated</th>
        <td mat-cell *matCellDef="let element">
          {{ element.lastUpdated ? (element.lastUpdated | hubDate: 'isoDate') : '' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="closedDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Closed</th>
        <td mat-cell *matCellDef="let element">
          {{ element.closedDate ? (element.closedDate | hubDate: 'isoDate') : '' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="boardName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Board</th>
        <td mat-cell *matCellDef="let element">{{ element.boardName }}</td>
      </ng-container>

      <ng-container matColumnDef="siteName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Site</th>
        <td mat-cell *matCellDef="let element">{{ element.siteName }}</td>
      </ng-container>
      @if (isBusinessUnitFlagEnabled) {
        <ng-container matColumnDef="businessUnitName">
          <th mat-header-cell *matHeaderCellDef style="text-align: center">Business Unit</th>
          <td mat-cell *matCellDef="let element" style="text-align: center">{{ element.businessUnitName ?? '-' }}</td>
        </ng-container>
      }
      <ng-container matColumnDef="contactFullName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Contact</th>
        <td mat-cell *matCellDef="let element">
          {{ element.contactFullName }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
    </table>
  </div>
  <mat-paginator
    class="table-paginator"
    [length]="numberOfTickets"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    (page)="onPageChange($event)"
    showFirstLastButtons
  >
  </mat-paginator>
</div>
